import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import { votingEscrowContract } from '../helpers/supportedContracts';
export var IncreaseAmount = createPlugin({
    protocol: 'CURVE',
    type: 'ACTION',
    method: 'increase_amount',
    name: 'increaseCurveTokenLockAmount',
    description: 'Deposit additional CRV into an existing lock.',
    supportedContracts: votingEscrowContract,
    getParams: function () { return ({
        input: {
            to: new FctAddress({ destination: 'curve_voting_escrow', options: votingEscrowContract, isPreview: true, }),
            methodParams: {
                value: new FctValue({ destination: 'wei_amount', decimals: 18, isPreview: true, }),
            },
        },
        output: {},
    }); },
    requiredApprovals: function (params) { return [
        {
            to: '0xD533a949740bb3306d119CC777fa900bA034cd52',
            params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams.value.value },
            method: 'approve',
            protocol: 'ERC20',
        },
    ]; },
});
